import React, { useEffect, useRef, useState } from "react";
import { Modal, ModalBody } from "@adeccoux/tag-ds";
import { useNavigate } from "react-router";
import Logo from "../../logo/logo.jpg";
import { getCall } from "../../util/resources";
import SesHeader from "../header";
import DisplayButton from "../../util/displaybutton";

const InformationScreen = ({ type, setInfoScreen, clientCobranding }) => {
    const templates = JSON.parse(sessionStorage.getItem("templates"));
    const phrases = JSON.parse(sessionStorage.getItem("phrases"));
    const welcomeTempRef = useRef();
    const navigate = useNavigate();

    let content = [];
    let isSyscheck = false;
    switch (type) {
        case "privacyStatement":
            const text = templates.dataPrivacyTemplate;
            content = [
                templates.dataPrivacyTemplateSub.replace(
                    "$Template.brandName",
                    ""
                ),
                text,
            ];
            break;
        case "termsOfUse":
            content = [
                templates.disclaimerTemplateSub.replace(
                    "$Template.brandName",
                    ""
                ),
                templates.disclaimerTemplate,
            ];
            break;
        case "startsyscheck":
            content = [
                "Syscheck",
                templates.scsyscheckTemplate,
                "SysCheck",
            ];
            isSyscheck = true;
            break;
        case "disclaimer":
            content = [
                templates.disclaimer2TemplateSub,
                templates.disclaimer2Template,
            ];
            break;
        case "surveyInstructions":
            const [instructions, setInstructions] = useState("");
            useEffect(() => {
                getCall("/rest/tt/getDecryptedData/").then((response) => {
                    setInstructions(response.data.response);
                });
            }, []);
            content = [phrases?.["14261"].replace(":", ""), instructions];
            break;
        case "surveyInstructions":

            break;

        default:
            break;
    }

    const GoSysCheck = () => {
        navigate("./sysCheck", { state: { clientCobranding: clientCobranding } });
    };

    return (
        <>
            <SesHeader clientCobranding={clientCobranding} />
            <div className="flex_col g2 align-items_center align-items_start_tablet align-items_start_tablet xpert-align-self-stretch justify-content_center">
                <h3 className="xpert-align-self-stretch">{content[0]}</h3>
                <div className="flex_col_mobile g3_mobile align-items_start_mobile xpert-align-self-stretch privacy-st-text "
                    ref={welcomeTempRef}
                    dangerouslySetInnerHTML={{
                        __html: content[1],
                    }}
                ></div>
            </div>
            <DisplayButton
                buttons={[
                    <button
                        className={
                            type === "surveyInstructions" ? "" : "text_uppercase button-secondary full-width_mobile "
                        }
                        onClick={() =>
                            type !== "surveyInstructions" && setInfoScreen(false)
                        }
                    >
                        {type !== "surveyInstructions" ? (
                            phrases?.["15073"]
                        ) : (
                            <>
                                <p>{phrases?.["15207"]}</p>
                                <span className="material-icons-outlined right">
                                    start
                                </span>
                            </>
                        )}
                    </button>,
                    isSyscheck && (
                        <button
                            className="button-primary text_uppercase align-items_right text_uppercase full-width_mobile "
                            style={{ float: "right" }}
                            onClick={GoSysCheck}
                        >
                            {content[2]}
                        </button>
                    ),
                ]}
            />
        </>
    );
};

export default InformationScreen;
